module.exports = __webpack_public_path__ + "img/3.536dacb9.png";